/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AttachmentPolicy } from './attachmentPolicy';

export type TaskEvaluationConfigAttachmentPolicy = AttachmentPolicy | null;
